/**
 * Só devolve a URL se o esquema for http(s). Qualquer outra coisa
 * (`javascript:`, `data:`, `vbscript:`, `file:`) vira null, para nunca
 * chegar a um `href`. Dado de anúncio/lead vem de terceiros.
 */
export function safeHttpUrl(value) {
  if (typeof value !== 'string') return null
  const text = value.trim()
  if (!/^https?:\/\//i.test(text)) return null
  try {
    const { protocol } = new URL(text)
    return protocol === 'http:' || protocol === 'https:' ? text : null
  } catch {
    return null
  }
}
